export const CHARACTERS: Record<string, { width: number; height: number }> = {
  player: { width: 36, height: 56 },
  // Enemigos: visual 95x135 -> hitbox ~55% x 75%
  pcc: { width: 50, height: 100 },
  fmc: { width: 54, height: 104 },
  ujc: { width: 52, height: 106 },
  'ujc-bat': { width: 52, height: 106 },
  police: { width: 52, height: 108 },
  inspector: { width: 54, height: 110 },
  cdr: { width: 60, height: 112 },
  // NPCs: visual 85x135 -> hitbox ~60% x 88% (interacción generosa)
  tourist: { width: 52, height: 120 },
  pioneer: { width: 44, height: 100 },
  jinetera: { width: 50, height: 118 },
  babalao: { width: 52, height: 122 },
  'street-vendor': { width: 52, height: 120 },
  civilian: { width: 52, height: 120 },
};

export function getEnemyData(_type: string): { width: number; height: number } {
  return { width: 52, height: 100 };
}

export const NPC_DEFINITIONS: Record<string, { category: string; width: number; height: number; interactRadius: number }> = {
  tourist: { category: 'reward', width: 52, height: 120, interactRadius: 40 },
  pioneer: { category: 'penalty', width: 44, height: 100, interactRadius: 30 },
  jinetera: { category: 'interactive', width: 50, height: 118, interactRadius: 35 },
  babalao: { category: 'ambient', width: 52, height: 122, interactRadius: 30 },
  'street-vendor': { category: 'ambient', width: 52, height: 120, interactRadius: 40 },
  civilian: { category: 'ambient', width: 52, height: 120, interactRadius: 30 },
};
